var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg001Folder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17.397,
    viewBox: "0 0 22 17.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -42.679)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44.978)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.9,87.292H9.965L8.386,85.416a.27.27,0,0,0-.216-.1h-6.4A1.779,1.779,0,0,0,0,87.1V98.639a1.779,1.779,0,0,0,1.777,1.777H17.9a1.779,1.779,0,0,0,1.777-1.777v-9.57A1.779,1.779,0,0,0,17.9,87.292Z",
    transform: "translate(0 -85.319)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.34 42.679)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.293,44.652H53.354l-1.579-1.876a.27.27,0,0,0-.216-.1h-6.4A1.777,1.777,0,0,0,43.4,44.214h5.839a1.033,1.033,0,0,1,.794.369l1.348,1.6h7.581A2.545,2.545,0,0,1,61.5,48.727v9.033A1.777,1.777,0,0,0,63.06,56v-9.57A1.779,1.779,0,0,0,61.293,44.652Z",
    transform: "translate(-43.4 -42.679)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001Folder);
export default __webpack_public_path__ + "static/media/001-folder.b2d7cfa9c763e60bcfe36f39c496da1f.svg";
export { ForwardRef as ReactComponent };